import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ArredamentoQuiz from "./pages/ArredamentoQuiz";
import Prodotti from "./pages/Prodotti";
import Commerce from "./pages/Commerce";
import Guarda from "./pages/Guarda";
import Consulenze from "./pages/Consulenze";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/arredamento" element={<ArredamentoQuiz />} />
        <Route path="/prodotti" element={<Prodotti />} />
        <Route path="/commerce/:id" element={<Commerce />} />
        <Route path="/consulenze" element={<Consulenze />} />
        <Route path="/guarda/:token" element={<Guarda />} />
        <Route path="/area-riservata" element={<AdminLogin />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
